import { render, staticRenderFns } from "./ProcessFactoryResetRequest.vue?vue&type=template&id=4124dd2b"
import script from "./ProcessFactoryResetRequest.vue?vue&type=script&lang=js"
export * from "./ProcessFactoryResetRequest.vue?vue&type=script&lang=js"
import style0 from "./ProcessFactoryResetRequest.vue?vue&type=style&index=0&id=4124dd2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports